import { Skeleton } from "@mui/material";
import { neutral } from "@flat-ui";

/** Number of rows to show in sidebar */
const NUMBER_OF_ROWS = 3;

/**
 * Renders a skeleton loading component for CardSelector component from flat-ui.
 * https://storybook.dev.holobuilder.com/flat-ui/?path=/docs/unstable-cardselector-cardselector--docs
 *
 * @returns {JSX.Element} The CardSelectorSkeleton component.
 */
export function CardSelectorSkeleton(): JSX.Element {
  return (
    <>
      {[...Array(NUMBER_OF_ROWS)].map((_, index) => (
        <Skeleton
          key={index}
          variant="rectangular"
          sx={{
            width: "100%",
            height: "104px",
            mb: "10px",
            backgroundColor: neutral[100],
          }}
        />
      ))}
    </>
  );
}
